export default __webpack_public_path__ + "static/media/crp.c3bf6751.svg";